import { __rest } from "tslib";
import { apiHolder, apis } from 'api';
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
class ScheduleTracker {
    constructor() {
        this.tracker = (...args) => {
            try {
                trackerApi.track.call(trackerApi, ...args);
            }
            catch (error) {
                console.warn('Hubble tracker invalite', error);
            }
        };
    }
    pc_create_schedule_add() {
        this.tracker('pc_create_schedule_add');
    }
    pc_schedule_detail_show(source) {
        this.tracker('pc_schedule_detail_show', { source });
    }
    pc_schedule_detail() {
        this.tracker('pc_schedule_detail');
    }
    pc_schedule_view(view) {
        this.tracker('pc_schedule_view', { view });
    }
    pc_schedule_change_view(view) {
        this.tracker('pc_schedule_change_view', { view });
    }
    pc_schedule_change(p) {
        this.tracker('pc_schedule_change', p);
    }
    pc_click_mail_schedule(category) {
        this.tracker('pc_schedule_blank', { category });
    }
    pc_schedule_add() {
        this.tracker('pc_schedule_add');
    }
    pc_schedule_follow() {
        this.tracker('pc_schedule_follow');
    }
    scheduleImport() {
        this.tracker('pc_schedule_import');
    }
    scheduleNewCatalog() {
        this.tracker('pc_schedule_new');
    }
    pcSchedule_show_PublicCalendar(option) {
        this.tracker('pcSchedule_show_PublicCalendar', option);
    }
    pcCalendar_click_addPublicCalendar() {
        this.tracker('pcCalendar_click_addPublicCalendar');
    }
    pcCalendar_click_setCalendar(option) {
        this.tracker('pcCalendar_click_setCalendar', option);
    }
    pcCalendar_click_button_addPublicCalendarPage(option) {
        this.tracker('pcCalendar_click_button_addPublicCalendarPage', option);
    }
    scheduleContact(options) {
        const { action } = options, attrs = __rest(options, ["action"]);
        this.tracker(`pc_contacts_schedule_${action}`, attrs);
    }
}
const scheduleTracker = new ScheduleTracker();
export default scheduleTracker;
